<template>
  <div>
    <el-form class="search_form" :model="searchForm"  ref="searchForm" size="mini" :inline="true"
      :rules="searchFormRules">
      <!--搜索框-->
      <el-col :span="3.5">
        <el-form-item prop="operatorId">
          <!--        <el-select placeholder="运营商" v-model="searchForm.operatorId" clearable>
          <el-option v-for="item in operatorForSelect" :key="item.id"
                     v-bind:label="item.name" v-bind:value="item.id"></el-option>
        </el-select>-->
          <el-cascader size="mini" clearable ref="cascader" placeholder="运营商" filterable :options="listForSelectTree"
            :show-all-levels="false" :props="{ checkStrictly:true,expandTrigger:'hover'}" change-on-select
            @change='changeOpertorId' v-model="searchForm.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="3.5">
        <el-form-item prop="stationId">
          <el-select v-model="searchForm.stationId" size="mini" placeholder="请选择站点 "  @change="change()" clearable>
            <el-option v-for="item in stations" :key="item.id" :label="item.stationName" :value="item.id">
              {{item.stationName}}
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="1.5">
        <el-form-item>
          <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
        </el-form-item>
      </el-col>
      <el-col :span="1.5">
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="submitSearchForm" :loading="searchLoading">查询
          </el-button>
        </el-form-item>
      </el-col>
       <el-col :span="1.5">
       <el-button type="primary" size="mini" @click="add()" :loading="searchLoading">新增
       </el-button>
     </el-col>
    </el-form>
  </div>
</template>

<script>
  import {
    validateInput
  } from '../../../../common/validator'
  export default {
    name: "search",
    data() {
      return {
        searchFormRules: {
          ruleName: [{
            validator: function(rule, value, callback) {
              validateInput(rule, value, callback, 0, 12, true, true, false, false, false, false, false)
            },
            trigger: 'blur'
          }],
        }
      }
    },
    props: {
      searchForm: {},
      listForSelectTree: '',
      stations: '',
      searchLoading: false,

    },
    methods: {
      resetSearchForm() {
        for (let item in this.searchForm) {
          if (this.searchForm[item]) {
            this.searchForm[item] = ''
          }
        }
        this.submitSearchForm()
      },
      change(){

        this.$forceUpdate()

      },
      add(){
        this.$emit("add")
      },
      changeOpertorId(value) {
        let operatorId = value && value.length > 0 ? value[value.length - 1] : ''
        this.searchForm.operatorId = operatorId
        this.searchForm.stationId=''

        this.$refs.cascader.dropDownVisible = false
        this.$emit("changeOpertorId")
      },
      submitSearchForm() {
        this.$emit("submitSearchForm")
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/dataCenter/page/stationPercentage/search.vue